export default "__VITE_ASSET__bd29905a__"